import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLoginMutation } from "../../../store/api/authApi";
import { setCredentials } from "../../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import InlineLoaderComponent from "../../../components/common/InlineLoaderComponent";
import InlineMessageComponent from "../../../components/common/InlineMessageComponent";
import BannerHeader from "../../../components/BannerHeader/BannerHeader";
import styles from "./login.module.css";
import green_rock from "../../../assets/images/green_rock.png";

import { toast } from "sonner";
import { Eye, EyeOff } from "react-feather";
import { FaXmark } from "react-icons/fa6";
// import { refetchAllQueries } from "../../../store/refetchAllQueries";
import { FaEnvelope, FaUser } from "react-icons/fa";
import { FiLock, FiMail } from "react-icons/fi";
const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const dispatch = useDispatch();
  const [
    login,
    { isLoading: loginInprogress, data: loginData, error: errorInLogin },
  ] = useLoginMutation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleLogin = async (formData) => {
    try {
      const response = await login(formData).unwrap();
      if (response?.data?.userData?.isActive) {
        dispatch(setCredentials(response?.data)); // assumes { user, token, refreshToken }
        localStorage.setItem("auth", JSON.stringify(response?.data));
        navigate("/");
        // refetchAllQueries(dispatch);
      } else {
        toast.error(response?.message);
      }
    } catch (err) {
      console.error("Login failed:", err);
    }
  };
  return (
    <>
      <BannerHeader />
      <div className={`${styles.mainContainer} container`}>
        <section className={styles.content}>
          <div className={styles.loginBox + " login-registration-container"}>
            <div className={styles.loginHeader}>
              <h1 className={styles.heading}>Login to continue</h1>
            </div>
            <InlineMessageComponent
              type={"error"}
              message={errorInLogin?.data?.message}
            />
            <form
              onSubmit={handleSubmit(handleLogin)}
              className="signup-login-form"
            >
              {/* Email Field */}
              <div className="form-group">
                {/* <label>Email*</label> */}
                <div className="position-relative">
                  <input
                    placeholder="Password"
                    className={`login-input form-input ${
                      errors.email ? "error" : ""
                    }`}
                    type="email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  <FiMail className="start-endronment" />
                </div>

                {errors.email && (
                  <span className="error-message">{errors.email.message}</span>
                )}
              </div>

              {/* Password Field */}
              <div className="form-group">
                {/* <label>Password*</label> */}
                <div className="position-relative">
                  <input
                    placeholder="Email address"
                    className={`login-input form-password ${
                      errors.password ? "error" : ""
                    }`}
                    type={showPassword ? "text" : "password"}
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters",
                      },
                    })}
                  />
                  <FiLock className="start-endronment" />
                  <div className={styles.eyeIcon}>
                    {showPassword ? (
                      <Eye onClick={() => setShowPassword(!showPassword)} />
                    ) : (
                      <EyeOff onClick={() => setShowPassword(!showPassword)} />
                    )}
                  </div>
                </div>
                {errors.password && (
                  <span className="error-message">
                    {errors.password.message}
                  </span>
                )}
              </div>

              {/* Remember Me Checkbox */}
              {/* <div className="form-group checkbox-group">
          <input
            className="form-checkbox"
            type="checkbox"
            id="rememberMe"
            {...register("rememberMe")}
          />
          <label htmlFor="rememberMe">Remember me</label>
        </div> */}

              <div className="auth-sub-link my-3 text-end">
                <Link className="text-primary" to="/forget-password">
                  Forget password?
                </Link>
              </div>

              <button type="submit" className="submit-button w-100">
                Login {loginInprogress && <InlineLoaderComponent />}
              </button>
            </form>
            <div className={styles.terms}>
              <p>
                By continuing, you agree to Green Rock's{" "}
                <a href="/terms" className={styles.link}>
                  Terms of Use
                </a>
                . Read our{" "}
                <a href="/privacy" className={styles.link}>
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Login;
